import { https } from "../http";
import store from "../store";
import { setUploadFileLoading } from "../store/reducers/document";

// Get Pre-Signed URL for Upload
export const getUploadUrlApi = async ({ filename, type }) => {
  try {
    store.dispatch(setUploadFileLoading(true));
    const res = await https().get("/me/generate-presigned-url", {
      params: {
        path: encodeURIComponent(filename), // Encode here
        contentType: type,
      },
    });
    return res?.data;
  } catch (error) {
    store.dispatch(setUploadFileLoading(false));
    console.error("Error fetching pre-signed URL", error);
    throw error;
  } finally {
    store.dispatch(setUploadFileLoading(false));
  }
};

export const putFileToS3Api = async ({ uploadURL, file }) => {
  try {
    // Create URL object to manipulate
    const urlObj = new URL(uploadURL);

    // Extract JUST the base URL without query parameters
    const cleanUrl = `${urlObj.origin}${urlObj.pathname}`;

    const res = await fetch(cleanUrl, {
      // Use clean URL here
      method: "PUT",
      headers: {
        "Content-Type": file.type,
        // Add this header for larger files
        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
      },
      body: file,
    });

    return res;
  } catch (error) {
    console.error("Error uploading file to S3", error);
    throw error;
  }
};

// Master Upload Function
export const uploadFileToS3Api = async ({ file }) => {
  try {
    if (!file) throw new Error("No file provided");

    const { uploadURL, path } = await getUploadUrlApi({
      filename: file.name,
      type: file.type,
    });

    // Create URL object to manipulate
    const urlObj = new URL(uploadURL);

    // Extract JUST the base URL without query parameters
    const cleanUrl = `${urlObj.origin}${urlObj.pathname}`;
    const uploadRes = await putFileToS3Api({ uploadURL, file });
    if (!uploadRes.ok) throw new Error("Failed to upload file to S3");
    return {
      message: "File uploaded successfully",
      uploadURL: cleanUrl, // full PUT url (used only once)
      path, // this should be the actual public S3 path if returned
    };
  } catch (error) {
    console.error("uploadFileToS3Api Error:", error);
    throw error;
  }
};
